import type {Variants} from 'framer-motion'

export const variants: Variants = {
  initial: {opacity: 0},
  animate: {opacity: 1, transition: {delay: 0.2, duration: 0.5, ease: 'easeInOut'}},
  exit: {opacity: 0, transition: {duration: 0.5}},
}

export const imageVariants: Variants = {
  initial: {opacity: 0.1},
  animate: {opacity: 1, transition: {delay: 0.3, duration: 0.7, ease: 'easeInOut'}},
  exit: {opacity: 0, transition: {duration: 0.5}},
}

export const motionProps = {
  initial: 'initial',
  animate: 'animate',
  exit: 'exit',
  variants,
}

export const motionImageProps = {
  initial: 'initial',
  animate: 'animate',
  exit: 'exit',
  variants: imageVariants,
}
